import type { Subscription } from "../types/subscription";

const AVG_DAYS_PER_MONTH = 30.4375;

export function monthlyEquivalent(sub: Subscription): number {
  const { amount, billing_cycle, custom_period_days } = sub;
  switch (billing_cycle) {
    case "monthly":
      return amount;
    case "yearly":
      return amount / 12;
    case "custom_days": {
      const days = custom_period_days && custom_period_days > 0 ? custom_period_days : 30;
      return (amount * AVG_DAYS_PER_MONTH) / days;
    }
    default:
      return 0;
  }
}

export function formatMoney(
  amount: number,
  currency: string,
  locale?: string,
): string {
  try {
    const loc =
      locale !== undefined && locale.trim() !== "" ? locale.trim() : undefined;
    return new Intl.NumberFormat(loc, {
      style: "currency",
      currency: currency || "USD",
      maximumFractionDigits: 2,
    }).format(amount);
  } catch {
    return `${amount.toFixed(2)} ${currency}`;
  }
}

export function daysUntil(dateIso: string): number {
  const target = new Date(dateIso + "T12:00:00");
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const diff = target.getTime() - today.getTime();
  return Math.ceil(diff / (1000 * 60 * 60 * 24));
}

export function isWithinDays(dateIso: string, maxDays: number): boolean {
  const d = daysUntil(dateIso);
  return d >= 0 && d <= maxDays;
}
